import { FC } from 'react'
import style from '@src/components/PersonalAccaunt/PersonalAccount.module.scss'

type BlockBalanceProps = {
  title: string
  result: number
  orangeStyle?: boolean
}

export const BlockBalance: FC<BlockBalanceProps> = ({ orangeStyle, title, result }) => (
  <div className={style.blockContainer}>
    <div className={style.title}>{title}</div>
    <div className={`${style.result} ${orangeStyle && style.orange} `}>{result}</div>
    <div className={style.description}>Белорусских рублей</div>
  </div>
)
